import api from '@/utils/api'
import { buildListQuery } from '@/utils/listQuery'

export default {
    getCups(page, size) {
        let range = '?range=' + encodeURIComponent(`[${page - 1},${size}]`)
        return api.get(`cup-leagues` + (page ? range : ''))
    },

    getFilteredCups(filter, page, size, sort) {
        return api.get(`cup-leagues` + buildListQuery({ filter, page, size, sort }))
    },

    getCup(id) {
        return api.get(`cup-leagues/${id}`)
    },

    getAllActiveCups() {
        let query = '?filter=' + encodeURIComponent('{"active": true }')
        return api.get(`cup-leagues` + query)
    },

    getAllCups() {
        return api.get(`cup-leagues/all`)
    },

    updateCup(id, data) {
        return api.put(`cup-leagues/${id}`, data)
    },

    createCup(data) {
        return api.post('cup-leagues', data)
    },

    deleteCup(id) {
        return api.delete(`cup-leagues/${id}`)
    }
}
